import { call } from "./api";

export const count = () => {
    return call(client => {
        return client.get(`/views/count`);
    });
};

export const all = () => {
    return call(client => {
        return client.get(`/views`, {
            params: { count: 0 }
        });
    })
};

export const search = params => {
    return call(client => {
        return client.get(`/views`, params);
    });
};
export const searchMonthlyDay = params => {
    return call(client => {
        return client.get(`/views/searchMonthlyDay`, params);
    });
};
/**
export const searchView = params => {
    return call(client => {
        return client.get(`/views/search`, params);
    });
};
**/
/**
export const searchByUser = params => {
    return call(client => {
        return client.get(`/users/views/all`, params);
    });
};
**/
export const add = params => {
    return call(client => {
        return client.post(`/views`, params);
    });
};

export const edit = (id, params) => {
    return call(client => {
        return client.put(`/views/${id}`, params);
    });
};

export const remove = (id, params) => {
    return call(client => {
        return client.delete(`/views/${id}`, params);
    });
};

export const batchRemove = (ids, params) => {
    const promises = ids.map(id => {
        return call(client => {
            return client.delete(`/views/${id}`, params);
        });
    });

    return Promise.all(promises);
};

// views
export const view = (params) => {
    return call(client => {
        return client.get(`/views`, params);
    });
};

export const csv = (params) => {
    return call(client => {
        return client.get(`/views/csv`, params);
    });
};
/**
export const addView = (params) => {
    return call(client => {
        return client.get(`/users/contents/${params.params.contentId}/view`, params);
    });
};
**/


// WEBPACK FOOTER //
// ./src/api/view.js